import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('lowGpaConcentrationWarning');

    return {
        description: (gpa: string, pct: string): string => t('description', { gpa, pct })
    };
};

export default useTranslation;
